// Cashier Transactions Vuex

import state from './debitCreditStates.js'
import * as getters from './debitCreditGetters.js'
import * as mutations from './debitCreditMutations.js'
import * as actions from './debitCreditActions.js'

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}
